async function cleanCache(): Promise<void> {
  await caches.keys().then(async (keyList) => Promise.all(keyList.map(async (key) => caches.delete(key))));
}

export default cleanCache;
